export default __webpack_public_path__ + "static/media/exterior (23).1074ea42.jpg";